var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"400px"}},[_c('l-map',{ref:"map",attrs:{"zoom":_vm.zoom,"center":_vm.center},on:{"click":_vm.onClick}},[_c('l-tile-layer',{attrs:{"url":_vm.url,"attribution":_vm.attribution}}),_c('l-marker',{attrs:{"lat-lng":_vm.marker}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }